import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const loader = () => import( /* webpackChunkName: "DashboardFilterInputs" */'./DashboardCRMFiltersList').then(module => module.DashboardCRMFiltersList);
export const AsyncDashboardCRMFiltersList = Loadable({
  loader,
  LoadingComponent: () => null
});